/**
 * This handles menus and drop downs
 */

export default {
    timeout: 0,
    event(callback) {
        ['resize', 'orientationchange'].forEach((element) => {
            window.addEventListener(element, () => {
                clearTimeout(this.timeout);
                this.timeout = setTimeout(() => {
                    callback(this.detect());
                }, 250);
            }, { passive: true });
        });
    },
    detect() {
        return {
            label: window.innerWidth < 768 ? 'mobile' : ( window.innerWidth <= 1023 ? 'tablet' : 'desktop'),
            mobile: window.innerWidth < 768,
            tablet: window.innerWidth >= 768 && window.innerWidth <= 1023,
            desktop: window.innerWidth >= 1024,
            orientation: window.innerWidth < window.innerHeight ? 'portrait' : 'landscape',
            width: window.innerWidth,
            height: window.innerHeight,
            browser: {
                chrome: (/Chrome/.test(navigator.userAgent) && /Google Inc/.test(navigator.vendor) && !!window.chrome) || /CriOS/.test(navigator.userAgent),
                safari: /Safari/.test(navigator.userAgent) && /Apple Computer/.test(navigator.vendor),
                firefox: /Firefox/.test(navigator.userAgent),
            },
            touch: 'ontouchstart' in document.documentElement,
        }
    }
};



